import { useQueryClient } from 'react-query';
import useHttpMutation from 'data/firestore/useHttpMutation';
import { ACTIONS_BASE_URL } from '../../../constants';
import {
    NexhealthLinkPatientBody,
    NexhealthPatientLinkEnvelope,
    NexhealthPatientLinkList,
} from '../types';

const useLinkNexhealthPatient = (agentId: string, customerId: string) => {
    const queryClient = useQueryClient();

    return useHttpMutation<NexhealthLinkPatientBody, NexhealthPatientLinkEnvelope>({
        method: 'POST',
        pathname: `/organizations/${agentId}/apps/nexhealth/patient-links`,
        server: ACTIONS_BASE_URL,
        onSuccess: (result) => {
            queryClient.setQueryData<NexhealthPatientLinkList>(
                ['nexhealth', 'patient-link', agentId, customerId],
                { data: [result.data], page: { nextCursor: null } },
            );
        },
    });
};

export default useLinkNexhealthPatient;
